import { makeStyles } from "@material-ui/core"

const useStyles = makeStyles({
	subtitle: {
		fontWeight: "normal"
	}
})

export default useStyles
